module.exports = __webpack_public_path__ + "static/media/dropdown_arw.c0b9537b.svg";